import React, { useEffect } from 'react';
import IminenciaDeserta from 'components/organisms/iminencia_deserta';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import tabId from 'services/tabId';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';

const IminenciaDeserted = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const allowedSaleSituations = ['Ativa', 'Em Analise'];

  useEffect(() => {
    document.title = 'Licitações Estratégicas - ConLicitação';
  }, []);

  return (
    <div className="page-container p-md-4 pt-3">
      {!profile.representant &&
        allowedSaleSituations.includes(profile.sale_situation) &&
        !profile.paralyzed && <IminenciaDeserta />}
      {!profile.representant && !allowedSaleSituations.includes(profile.sale_situation) && (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      )}
      {profile.representant &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) &&
        !profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado && <IminenciaDeserta />}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        !allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
    </div>
  );
};
export default IminenciaDeserted;
